import React from 'react';
import classNames from 'classnames';
import styles from './SVGIcon.scss';

export default function LogOutIcon({ className, size = 'xsmall' }) {
  return (
    <span className={classNames(styles.svgIcon, className, styles[size])}>
      <svg viewBox="0 0 20 20" fill="none">
        <path
          id="Icon"
          d="M6.66667 5.83333L2.5 10M2.5 10L6.66667 14.1667M2.5 10L12.5 10M10 5.83333C10 5.05836 10 4.67087 10.0852 4.35295C10.3164 3.49022 10.9902 2.81635 11.853 2.58519C12.1709 2.5 12.5584 2.5 13.3333 2.5H13.75C14.9149 2.5 15.4973 2.5 15.9567 2.6903C16.5693 2.94404 17.056 3.43072 17.3097 4.04329C17.5 4.50272 17.5 5.08515 17.5 6.25V13.75C17.5 14.9149 17.5 15.4973 17.3097 15.9567C17.056 16.5693 16.5693 17.056 15.9567 17.3097C15.4973 17.5 14.9149 17.5 13.75 17.5H13.3333C12.5584 17.5 12.1709 17.5 11.853 17.4148C10.9902 17.1836 10.3164 16.5098 10.0852 15.647C10 15.3291 10 14.9416 10 14.1667"
          stroke="var(--color-icon-lineart)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
